import { observer } from "mobx-react-lite";
import { MdsVirtualizedItemList } from "@/design-system/components/item-list";
import { useTabPageStore } from "@/hooks/useTabPageStore";
import { TemplatesListPageEmpty } from "@/pages/templates-list/components/TemplatesListPageListEmpty";

export const TemplatesListPageList = observer(() => {
  const page = useTabPageStore("templatesListPage");

  if (!page.itemRows.length) {
    return <TemplatesListPageEmpty />;
  }

  return <MdsVirtualizedItemList rows={page.itemRows} loading={false} />;
});
